import type {
  Commune,
  Region,
  RegionWithCommune
} from '@/modules/region/domain/Region';
import type { QueryHook } from '@/sections/shared/types/QueryHook';

import { useRegionContext } from '../RegionContext';

interface UseRegionsUtilities {
  getRegionById: (regionId: string) => Region | undefined;
  getCommuneById: (region: Region, communeId: string) => Commune | null;
  getRegionAndCommuneByIds: (
    regionId?: string | number,
    communeId?: string
  ) => RegionWithCommune | null;
}
const useRegions = (): QueryHook<Region[]> & UseRegionsUtilities => {
  const { regions } = useRegionContext();

  const { data: allRegions } = regions || [];

  const getRegionById = (regionId?: string | number) =>
    allRegions?.find(
      (region) => region?.id?.toString() === regionId?.toString()
    );

  const getCommuneById = (region: Region, communeId?: string | number) => {
    return (
      region?.communes?.find(
        (commune) => commune?.code?.toString() === communeId?.toString()
      ) ?? null
    );
  };

  const getRegionAndCommuneByIds = (
    regionId?: string | number,
    communeId?: string | number
  ): RegionWithCommune | null => {
    const region = getRegionById(regionId);

    if (!region) return null;

    const commune = getCommuneById(region, communeId);

    const regionAndCommune: RegionWithCommune = {
      ...region,
      commune: commune ? [commune] : []
    };

    return regionAndCommune;
  };

  return {
    ...regions,
    getRegionById,
    getCommuneById,
    getRegionAndCommuneByIds
  };
};

export default useRegions;
